import styled, { keyframes } from 'styled-components';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'

export const CheckoutModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    overflow: auto;
`;

export const ModalContainer = styled.div`
    background: ${props => props.hasImage ? `url(${props.src}) no-repeat center center / cover` : 'white'};
    padding: 20px;
    border-radius: 8px;
    max-width: 600px;
    width: 100%;
    height: fit-content;
    justify-content: center;
    align-items: middle;
    display: flex;
    margin-top: 150px;
    margin-bottom: 150px;
    flex-direction: column;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    @media screen and (max-width: 490px){
     margin-top: 80px;
     max-width: 600px;
    }
`;

export const ModalCenterButton = styled.button`
  border-radius: 50px;
  background: #c2b280;
  white-space: nowrap;
  padding: 2px 8px;
  color: #ffffff;
  font-size: 24px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  text-align: center;
  margin:2px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #c2b280;
  }
`;

export const ModalOptionButton = styled.button`
  border-radius: 10px;
  background-color: ${({ selected }) => (selected ? '#c2b280' : '#fff')};
  white-space: nowrap;
  padding: 2px 8px;
  color: ${({ selected }) => (selected ? '#fff' : '#c2b280')};;
  font-size: 16px;
  outline: none;
  border-color: #c2b280;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  text-align: center;
  margin:2px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #c2b280;
    color: #fff;
  }
`;


export const ModalFooter = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const ModalCloseButton = styled.button`
  border-radius: 50px;
  background: none;
  white-space: nowrap;
  padding: 2px 8px;
  color: #c2b280;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  text-align: center;
  margin:2px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #c2b280;
  }
`;

export const ModalButton = styled.button`
  border-radius: 50px;
  background: #c2b280;
  white-space: nowrap;
  padding: 2px 8px;
  color: #ffffff;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  text-align: center;
  margin:2px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #c2b280;
  }
`;

export const ModalMessage = styled.text`
    color: #c2b280;
    text-align: center;
`;

export const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const SpinningIcon = styled(AiOutlineLoading3Quarters)`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #c2b280;
  border-radius: 50%; 
  width: 24px; 
  height: 24px; 
  animation: ${spin} 1s linear infinite;
`